/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WalletConsumptionConfiguration } from '../../models/wallet-consumption-configuration';

export interface GetWalletConsumptionSettings$Params {
}

export function getWalletConsumptionSettings(http: HttpClient, rootUrl: string, params?: GetWalletConsumptionSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletConsumptionConfiguration>> {
  const rb = new RequestBuilder(rootUrl, getWalletConsumptionSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WalletConsumptionConfiguration>;
    })
  );
}

getWalletConsumptionSettings.PATH = '/v1/api/admin-ui/company/consumption-settings';
